import React from 'react';

import { SVGComponentProps } from './svg.types';

const PlayMediaSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.1259 6.28609L3.12591 0.288378C2.82245 0.106131 2.47607 0.00768696 2.12212 0.00309782C1.76818 -0.00149132 1.41935 0.0879392 1.11128 0.262257C0.803199 0.436574 0.546906 0.689533 0.368568 0.9953C0.19023 1.30107 0.0962385 1.64869 0.0961914 2.00266V14.0027C0.0962385 14.3566 0.19023 14.7043 0.368568 15.01C0.546906 15.3158 0.803199 15.5688 1.11128 15.7431C1.41935 15.9174 1.76818 16.0068 2.12212 16.0022C2.47607 15.9976 2.82245 15.8992 3.12591 15.7169L13.1259 9.71466C13.4217 9.53689 13.6665 9.28558 13.8365 8.98518C14.0064 8.68478 14.0957 8.34552 14.0957 8.00038C14.0957 7.65524 14.0064 7.31597 13.8365 7.01557C13.6665 6.71517 13.4217 6.46387 13.1259 6.28609V6.28609Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default PlayMediaSVG;
